module.exports = __webpack_public_path__ + "img/FI21233057.9795800e.svg";